import { Collection } from 'modules/core/lib/mobx-rest'

import Schema from 'modules/custom_resources/store/models/customResources/Schema'

class SchemasCollection extends Collection<Schema> {
  get cacheKey(): string {
    return 'schemas'
  }

  get indexes() {
    return ['name']
  }

  model() {
    return Schema
  }
}

const singleton: SchemasCollection = new SchemasCollection()

export default singleton
